import { Button } from "plos/src/components/buttons/Button";
import RefreshIcon from "plos/src/img/icons/refresh.svg?react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { squadActionsBarWrapper } from "./squadActionsBar.css";

interface SquadActionsBarProps {
  handleAutoPick: () => void;
  handleAutoPickAgain: () => void;
  handleReset: () => void;
  isAutoPickDisabled: boolean;
  isAutoPickTeam: boolean;
  isValidSquad: boolean;
  isResetDisabled: boolean;
  children: ReactNode;
}

const SquadActionsBar = ({
  handleAutoPick,
  handleAutoPickAgain,
  handleReset,
  isAutoPickDisabled,
  isAutoPickTeam,
  isValidSquad,
  isResetDisabled,
  children,
}: SquadActionsBarProps) => {
  const { t } = useTranslation("squad");

  // Allow auto pick again if squad is user has just used team builder to generate a team
  const autoPickAction = isAutoPickTeam ? handleAutoPickAgain : handleAutoPick;

  return (
    <div
      className={squadActionsBarWrapper}
      role="group"
      aria-label={
        t(
          "manageSquad.squadActionsBar.label",
          "squad pitch action buttons",
        ) as string
      }
    >
      <Button
        isDisabled={isAutoPickDisabled || (isValidSquad && !isAutoPickTeam)}
        onPress={autoPickAction}
        appearance="outlined"
      >
        {isAutoPickTeam ? (
          <>
            <RefreshIcon height={14} width={14} />
            {t("manageSquad.squadActionsBar.autoPickAgain", "Auto Pick Again")}
          </>
        ) : (
          t("manageSquad.squadActionsBar.autoPick", "Auto Pick")
        )}
      </Button>
      <Button
        appearance="outlined"
        isDisabled={isResetDisabled}
        onPress={handleReset}
      >
        {t("manageSquad.squadActionsBar.reset", "Reset")}
      </Button>
      {children}
    </div>
  );
};

export default SquadActionsBar;
